/**
 * Central registry for the CanniComply branded artwork.
 * Owner-supplied assets — do not replace with stock imagery.
 * Update URLs here to swap the visuals across the site.
 */

const BASE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_cannicomply-premium/artifacts";

export const artwork = {
  // Primary brand mark — used for OG social share + subtle watermark.
  logo: `${BASE}/pr2u5ej5_Gemini_Generated_Image_bx77a6bx77a6bx77.png`,

  // Square social poster — "CAN YOU PROVE IT?" — sits inside InspectorMoment.
  proveIt: `${BASE}/jodc2z2v_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2008_41_22%20AM.png`,

  // Wide poster — "INSPECTION READY. EVERY DAY." — sits inside BottomCTA.
  // Currently using the locally-generated, evidence-focused version (four-line
  // subhead: policy acknowledged / assessment completed / certificate
  // verifiable / audit event retained). To revert to the original owner-supplied
  // human-figure version, swap the URL below with:
  //   `${BASE}/ie91sbar_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2008_22_56%20AM.png`
  inspectionReady: "/generated/inspection-ready.jpg",

  // UKCSL wide banner — "Building technology and community" — sits inside About.
  ukcslBanner: `${BASE}/7mfvohsu_ChatGPT%20Image%20Jul%2020%2C%202026%2C%2008_46_42%20AM.png`,
};
